import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const depositHistorySchema = z.object({
  /** 入金識別uuid */
  uuid: z.string(),
  /** 入金address */
  address: z.string().optional(),
  /** アセット名 */
  asset: z.string(),
  /** ネットワーク名 */
  network: z.string().optional(),
  /** 入金数量 */
  amount: decimalSchema,
  /** 入金トランザクションID(暗号資産の時のみ) */
  txid: z.string().nullable().optional(),
  /** 入金状態: FOUND, CONFIRMED, DONE */
  status: z.union([
    z.literal('FOUND'),
    z.literal('CONFIRMED'),
    z.literal('DONE'),
  ]),
  /** 検知UNIXタイムスタンプ(ミリ秒) */
  found_at: z.number().int(),
  /** 承認(残高追加確定時)UNIXタイムスタンプ(ミリ秒、承認後のみ存在) */
  confirmed_at: z.number().int().nullable().optional(),
})

export const responseSchema = z.object({
  data: z.object({
    deposits: z.array(depositHistorySchema),
  }),
})
